
import { getCurrentInstance, watch } from 'vue'
import RelatedData from '../../../components/insights/analytics/queries/related-data.component.vue'
import { EpbCard } from '../../../components/shared/epb-card'
import { EpbText } from '../../../components/shared/epb-text'
import { mapActions, useContextQuery } from '../../../composables'
import { useReloadDistDataWhenFiltersChange } from '../../../composables/use-reload-dist-data-when-filters-change'
import { ANALYTICS_CONSTS } from '../../../store'
import SearchDataNoResults from './search-data-no-results.component.vue'

export default {
  name: 'SearchData',
  components: {
    EpbCard,
    EpbText,
    RelatedData,
    SearchDataNoResults,
  },
  setup(_, { emit }) {
    const {
      proxy: { $epb, $store },
    } = getCurrentInstance()

    const { query } = useContextQuery()

    const { setSelectedId } = mapActions($store, ANALYTICS_CONSTS.moduleName, {
      setSelectedId: ANALYTICS_CONSTS.actions.setSelectedId,
    })

    const messages = $epb.messages.explain.queryAnalysis.sections.searchData

    const { isLoading } = useReloadDistDataWhenFiltersChange()

    watch(isLoading, (isLoading: boolean): void => {
      emit('isLoading', isLoading)
    })

    watch(
      query,
      async (query: string): Promise<void> => {
        return await setSelectedId(query)
      },
      { immediate: true },
    )

    return {
      baseClass: 'epb-search-data',
      messages,
    }
  },
}
